import {
  FlexRowCenterHorizontal,
  LoadingSpinner,
  ModalRaw,
  removeQueryParams,
  useRouter,
} from '@main/core-ui';
import AvatarPopover from '@main/privacy-center/src/components/AvatarPopover';
import ActiveDataSubject from '@main/privacy-center/src/containers/ActiveDataSubject';
import {
  selectAuthSecret,
  selectCoreIdentifier,
  selectIsLoggingIn,
  selectSessionProfile,
} from '@main/privacy-center/src/containers/App/selectors';
import { Login } from '@main/privacy-center/src/containers/Login';
import { useLogout } from '@main/privacy-center/src/hooks';
import { sp } from '@main/theme';
import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { selectActiveDataSubject } from '../ActiveDataSubject/selectors';
import EmailLogin from './EmailLogin';
import { sessionManagerMessages } from './messages';
import { selectSupportEmail } from './selectors';

export interface SessionManagerProps {
  /** Explicit onExited function with context of modal button ref */
  onExited: () => void;
}

/**
 * Display the logged in session or prompt for login
 */
export const SessionManager: React.FC<SessionManagerProps> = ({ onExited }) => {
  const { formatMessage } = useIntl();
  const supportEmail = useSelector(selectSupportEmail);

  const authSecret = useSelector(selectAuthSecret);
  const sessionProfile = useSelector(selectSessionProfile);
  const coreIdentifier = useSelector(selectCoreIdentifier);
  const isLoggingIn = useSelector(selectIsLoggingIn);
  const logout = useLogout();

  const activeDataSubject = useSelector(selectActiveDataSubject);
  const { redirect, location, queryParams } = useRouter();

  return (
    <div style={{ marginLeft: sessionProfile ? sp(1) : 0 }}>
      <ActiveDataSubject hide />
      {sessionProfile ? (
        // Logged in
        <AvatarPopover
          {...sessionProfile}
          coreIdentifier={coreIdentifier}
          supportEmail={supportEmail}
          logout={logout}
        />
      ) : !authSecret &&
        activeDataSubject &&
        activeDataSubject.loginInstructions ? (
        // Login should open a modal
        <React.Fragment>
          <ModalRaw
            show={queryParams.modal === 'log-in'}
            onHide={() =>
              redirect(removeQueryParams(location, ['modal', 'action']))
            }
            onExited={onExited}
            width="600px"
            centered
            header={sessionManagerMessages.label}
          >
            <p>{formatMessage(activeDataSubject.loginInstructions)}</p>
            {activeDataSubject.redirectUrl ? <Login /> : <EmailLogin />}
          </ModalRaw>
        </React.Fragment>
      ) : !authSecret &&
        activeDataSubject &&
        activeDataSubject.redirectUrl ? null : isLoggingIn ? ( // Can login via direct redirect
        // Should never reach here, but in odd case when no response, no text, and no redirect URL, display nothing
        <FlexRowCenterHorizontal>
          <LoadingSpinner />
        </FlexRowCenterHorizontal>
      ) : (
        <></>
      )}
    </div>
  );
};

export default SessionManager;
